; "use_strict";
(function defSideBar(global) {

  var cssClass = "tab_item";

  /**
  * Часто используемые селекторы
  */
  var noCardFormAtStartFound = false;

  var tabSelector = "div.tab_item";
  var byNameSelectorTemplate = "{0}[name='{1}']";
  var cardFormTabTemplate = '#CardForm_Tab_{0}';
  var cardFormTabSelector = 'div.CardForm_Tab';

  /**
  * У проводника немного другая верстка
  */
  /*if (global.getLocation() == "explorer") {
    sideBarConatainerSelector = "#sidebar_container";
    tabSelector = "div.sidebar_item";
    cssClass = "sidebar_item";
  }*/
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Частоиспользуемые jQuery объекты
  */

  /**
  * Класс-обертка для панели закладок
  * @class WebAccess.components.wrappers.sideBar.SideBar
  * @since 5.2.0.1600
  */
  var SideBar = BaseObject.extend({
    _jContainer: null,
    _current: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (containerSelector, current) {
      var me = this;
      me._current = current;
      me._jSideBar = $(containerSelector);
      me._jAfterTabs = me._jSideBar.find(".after_tabs");
      me._super();


      // Не появляется горизонтальный скроллинг в детальном разделе, пока не
      // пошевелишь колонки
      // #106665
      // Это может быть медленно, особенно где много вкладок и таблиц
      me.bind(me['class'].EVENT.AFTER_TAB_SWITCH, function () {
        _(me._current._getGrids()).each(function (grid) {
          grid.grid.resizeCanvas();

          // #106257 Поле в детальном разделе не становится активным. Помогает обновление страницы
          grid.grid.resetActiveCell();
        });
      });

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика сворачивания / разорачивания горизонтальных закладок в кнопку еще.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_fitHorizontalTabs
    * @private
    * @since 5.2.0.1600
    * @return {WebAccess.current.sideBar}
    */
    _fitHorizontalTabs: global.TCD(function () {
      var me = this;
      if (me._jSideBar.length > 0) {
        return this._fitTabs('outerWidth', Math.min(windowWidth(), me._jSideBar.width())); //В карточке ЗЗУ есть вложения, которые уменьшают область горизонтальных вкладок.
      };
      return false;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика сворачивания / разорачивания вертикальных закладок в кнопку Еще.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_fitVerticalTabs
    * @private
    * @since 5.2.0.1600
    * @return {WebAccess.current.sideBar}
    */
    _fitVerticalTabs: global.TCD(function () {
      var me = this;
      if (me._jSideBar.length > 0) {
        return this._fitTabs('outerHeight', me._current._getAvailableHeight())
      }
      return false;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Подсчет ширины или высоты всех закладок.
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_getSideBarSize
    * @since 5.2.0.1600
    * @private
    * @param {object} jSideBar - контейнер сайдбара
    * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
    * @return {integer} ширина сайдбара
    */
    _getSideBarSize: function (sizeName) {
      var me = this;
      var sideBarSize = 0;

      me._jSideBar.find('span:first').find(tabSelector).each(function () {
        sideBarSize += $.fn[sizeName].call($(this), true);
      });

      if (!this.isVertical()) sideBarSize += $(".more").width();
      return sideBarSize;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение ширины или высоты последней нескрытой закладки (не учитывая закладку "Еще").
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_getLastTabSize
    * @since 5.2.0.1600
    * @private
    * @param {object} jSideBar - контейнер сайдбара
    * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
    * @return {integer}
    */
    _getLastTabSize: function (sizeName) {
      var me = this;
      var tabs = me._jSideBar.find('span:first').find(tabSelector);
      return $.fn[sizeName].call(tabs.not('.more').last(), true);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Логика сворачивания / разворачивания закладок в кнопку "Еще".
    *
    * @function WebAccess.components.wrappers.sideBar.SideBar#_fitTabs
    * @private
    * @since 5.2.0.1600
    * @param {string} sizeName - измерение (доступные значения: 'outerWidth', 'outerHeight').
    * @param {integer} availableSize - доступная максимальная величина измерения.
    * @return {WebAccess.current.sideBar}
    */
    _fitTabs: global.TCD(function (sizeName, availableSize) {
      var me = this;
      me._current.states.tabs.done(function () {
        var sideBarSize = me._getSideBarSize(sizeName);

        var jMore = me._jSideBar.find('div.more');

        var stop = true;
        if (availableSize < sideBarSize) {
          var moreSize = 0;
          if (me.isVertical()) {
            moreSize = $.fn[sizeName].call(jMore, true);
            if (me._jAfterTabs.find(tabSelector).length > 0 && jMore.length > 0) {
              moreSize = 0;
            }
          }

          while (stop && (availableSize < sideBarSize - moreSize)) {
            stop = me.collapse();
            jMore = me._jSideBar.find('div.more');
            sideBarSize = me._getSideBarSize(sizeName);
            if (me.isVertical() && jMore.width() > 0) { moreSize = 0; }
          };
        } else {
          var lastSize = me._getLastTabSize(sizeName);
          var moreSize = $.fn[sizeName].call(jMore, true);
          while (stop && (availableSize > sideBarSize + lastSize)) {
            stop = me.expand();
            lastSize = me._getLastTabSize(sizeName);
            sideBarSize = me._getSideBarSize(sizeName);
          };
        };
      });
      return me;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Восстановить спрятанные закладки
    * Спрятать кнопку "Еще".
    *
    * @private
    * @method WebAccess.components.wrappers.sideBar.SideBar#_internalExpand
    * @since 5.2.0.1600
    * @return {boolean} имеется ли возможность дальнейшего разворачивания
    */
    _internalExpand: global.TCD(function (jSideBar) {
      var me = this;
      var firstTab = me._jAfterTabs.find(tabSelector + ":first");
      var prevId = firstTab.data('prevId');


      if (prevId) $('#' + prevId).after(firstTab);
      else me._jSideBar.find(tabSelector + ":first").before(firstTab);

      //Когда скрыт всего один элемент, смысла в кнопке еще нет.
      var tabsLeft = me._jAfterTabs.find(tabSelector);
      if (tabsLeft.length === 1) {
        me._internalExpand();
      };

      var firstTab = me._jAfterTabs.find(tabSelector + ":first");
      if (firstTab.length == 0) {
        if (!!this.tabs["More"]) {
          //this.tabs["More"].hide();
          me.tabs["More"]._jObject.remove();
          delete me.tabs["More"];
        }
        return false;
      }
      return true;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Показать кнопку "Еще".
    * Спрятать все, что не влазит в неё.
    * Создать выпадющее меню по аналогии с группами.
    *
    * @since 5.2.0.1600
    * @private
    * @method WebAccess.components.wrappers.sideBar.SideBar#_internalCollapse
    * @return {boolean} имеется ли возможность дальнейшего сворачивания
    */
    _internalCollapse: global.TCD(function () {
      var me = this;

      if (!me.tabs["More"]) {

        me.tabs.create("More")
          .setLabel(L("MORE_TABS"))
          .setTooltip(L("OTHER_TABS"))
          .setIcon("ToolbarAndTab/More.png")
          .click($.noop);

        me.tabs["More"]._jObject.click(function (e) {
          e.stopPropagation();
          me._jAfterTabs.toggleClass("hidden");

          var jLeftColumn = me._jSideBar;
          if (jLeftColumn.hasClass('horizontal')) {
            var left = $(this).offset().left;
            var afterTabsWidth = me._jAfterTabs.width();

            if (left + afterTabsWidth > windowWidth()) {
              left = windowWidth() - afterTabsWidth - 10;
            }
            me._jAfterTabs.css({ 'left': left });
          } else {
            var top = $(this).position().top;// + $(this).parents('.ui-dialog-content').scrollTop() - $(this).outerHeight()/2;
            var left = me.tabs["More"]._jObject.outerWidth();

            var width = 0;
            var jTabs = me._jAfterTabs.find(tabSelector);

            jTabs.last().css({ 'marginRight': 0 });
            jTabs.each(function () {
              width += $(this).outerWidth(true);
            })
            me._jAfterTabs.css({ 'top': top, 'width': width, 'left': left });
          }
          $('.CardForm').redraw(); //#106605
        });

      } else {
        this.tabs["More"].show();
      };

      var jMore = me._jSideBar.find(this.tabs["More"].selector).addClass("more");
      var lastTab = jMore.prev(tabSelector);
      if (lastTab.length < 1) return false;

      if (lastTab.hasClass('selected')) {
        lastTab = lastTab.prev(tabSelector);
        if (lastTab.length < 1) return false;
      }

      lastTab.data('prevId', lastTab.prev().attr('id'));
      me._jAfterTabs.prepend(lastTab);

      return true;
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Развернуть содержимое закладок или дерево задач в проводнике.
    * В карточках объектов пошагово переносит скрытые закладки с закладки «Еще» на боковую панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#expand
    */
    expand: global.TCD(function () {
      return this._internalExpand();
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Свернуть содержимое закладок или дерево папок в проводнике.
    * В карточках объектов пошагово переносит закладки с боковой панели на закладку «Еще».
    * @method WebAccess.components.wrappers.sideBar.SideBar#collapse
    * @param {string} tabName Имя закладки
    * @return {WebAccess.current.sideBar | boolean} True – имеется возможность свернуть содержимое закладок, иначе False.
    */
    collapse: global.TCD(function () {
      return this._internalCollapse();
    }),
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить, свернута ли боковая панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#isCollapsed
    * @param {String} tabName Имя закладки
    * @since 5.2.0.1600
    */
    isCollapsed: function () {
      var me = this;
      return !$("#tree_container").is(":visible"); //FIXME
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Изменить расположение боковой панели.
    *

    * @method WebAccess.components.wrappers.sideBar.SideBar#setOrientation
    * @todo проверить в разных местах, например в проводнике, мастерах
    * @fixme с иконками в обратную сторону пока плохо.
    * @param {ORIENTATION} orientation Режим расположения боковой панели.
    * Возможные значения:HORIZONTAL – горизонтальное; VERTICAL – вертикальное.
    * @since 5.2.0.1600
    * @example
    *
    * //Установить горизонтальное расположение боковой панели.
    * WA.CR.sideBar.setOrientation(ORIENTATION.HORIZONTAL)
    */
    setOrientation: function (orientation) {
      var me = this;

      if (orientation == ORIENTATION.HORIZONTAL) {
        me._jSideBar.removeClass("vertical").addClass("horizontal");
        $("#right_column").addClass("no_margin");
        me._jSideBar.find(tabSelector + " p").each(function () {
          var smallIcon = $(this).data('smallicon');
          $(this).removeClass().addClass(smallIcon);
        });

        this._fitHorizontalTabs();
      } else {
        me._jSideBar.addClass("vertical").removeClass("horizontal");

        $("#right_column").removeClass("no_margin");
        me._jSideBar.find(tabSelector + " p").each(function () {
          var icon = $(this).data('icon');
          $(this).removeClass().addClass(icon);
        });

        this._fitVerticalTabs();
        this.moveSidebarToLeftColumn();
      };

      // Скрывает панель "Еще".
      $('body').off('click.tabs').on('click.tabs', function () {
        me._jAfterTabs.addClass("hidden");
      });

      // Сворачивает вкладки в "Еще" при изменении размеров экрана.
      $(window).bind('resizeEnd', function () {
        me._jAfterTabs.addClass("hidden");
        if (me._jSideBar.hasClass("horizontal")) {
          me._fitHorizontalTabs();
        } else {
          me._fitVerticalTabs();
        };
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверить, вертикально ли распологается боковая панель.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#isVertical
    * @since 5.0.0.4206
    * @return {boolean} True – боковая панель располагается вертикально, иначе False.
    */
    isVertical: function () {
      var me = this;
      return !$("#left_column").hasClass("horizontal");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить первоначальное положение закладок боковой панели.
    *
    * @method WebAccess.components.wrappers.sideBar.SideBar#moveSidebarToLeftColumn
    * @since 5.2.0.1600
    */
    //
    moveSidebarToLeftColumn: function () {
      var me = this;
      var jLeftColumn = $('#left_column');
      var jRightColumn = $('#right_column');
      // Перенос.
      jRightColumn.before(jLeftColumn);
      // Корректируем стили левой колонки.
      //jLeftColumn.css({ 'width': '', 'marginRight': '' }); //FIXME: проверить на планшетах
      // Корректируем размер полей текста ЗЗУ.
      if (typeof (initSavedTextHeight) !== 'undefined') initSavedTextHeight();
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
    EVENT: {
      /**
      * Срабатывает до смены закладки
      * @event WebAccess.components.wrappers.sideBar.SideBar.EVENT.BEFORE_TAB_SWITCH
      * @param {WebAccess.components.wrappers.sideBar.Tab} закладка,
      * на которую произошло переключение
      * @since 5.2.0.1304
      */
      BEFORE_TAB_SWITCH: 'beforeTabSwitch',
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * Срабатывает после смены закладки
      * @event WebAccess.components.wrappers.sideBar.SideBar.EVENT.AFTER_TAB_SWITCH
      * @param {WebAccess.components.wrappers.sideBar.Tab} закладка,
      * на которую произошло переключение
      * @since 5.2.0.1304
      */
      AFTER_TAB_SWITCH: 'afterTabSwitch'
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    }
  }
  );

  WA.CMP.wrappers.sideBar.SideBar = SideBar;

})(window.WA);
